import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';

import WebFont from 'webfontloader';
import Alert from 'react-s-alert';

import Login from './containers/Login';
import PrivateRoute from './containers/PrivateRoute';
import { Home, HomeNavigation} from './containers/Home';
import { Admin, AdminNavigation } from './containers/Admin';
import { Element, ElementNavigation } from './containers/Element';

import Layout from './containers/Layout/index';

import store from './store';

import 'react-table/react-table.css'
import 'react-s-alert/dist/s-alert-default.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import 'rc-tooltip/assets/bootstrap_white.css';
import 'rc-color-picker/assets/index.css';
import './global.css';

WebFont.load({
  google: {
    families: ['Nunito', 'sans-serif'],
  },
});

/* eslint-disable no-undefined */
ReactDOM.render(
  (
    <Provider store={store}>
      <Router>
        <div style={{width: '100%', height: '100%'}}>
          <Alert stack={{limit: 3}} />
          <Switch>
          <Route path="/login" component={Login} />
          <Layout
            navigation={
              <Switch>
                <Route exact path="/" component={HomeNavigation} />
                <Route exact path="/admin" component={AdminNavigation} />
                <Route exact path="/element/:id" component={ElementNavigation} />
              </Switch>
            }
            content={
              <Switch>
                <PrivateRoute exact path="/" component={Home} />
                <PrivateRoute exact path="/admin" component={Admin} />
                <PrivateRoute exact path="/element/:id" component={Element} />
              </Switch>
            }
            />
          </Switch>
        </div>
      </Router>
    </Provider>
  ), document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js